import { render, staticRenderFns } from "./PlanMainPage.vue?vue&type=template&id=68f6acf0&scoped=true"
import script from "./PlanMainPage.vue?vue&type=script&lang=js"
export * from "./PlanMainPage.vue?vue&type=script&lang=js"
import style0 from "./PlanMainPage.vue?vue&type=style&index=0&id=68f6acf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f6acf0",
  null
  
)

export default component.exports